<div class="live-action-bar">
  <div class="live-action-bar__links">
    <a class="live-action-bar__link link" (click)="refresh.emit()" [tabIndex]="0">
      <ftr-icon color="Primary" size="Small" icon="InProgress" align="Sub"></ftr-icon>
      Refresh
    </a>
    <a class="live-action-bar__link link" (click)="toggleAutoUpdate()" [tabIndex]="0">
      <ftr-icon
        color="Primary"
        size="Small"
        [icon]="isAutoUpdateEnabled ? 'PauseCircleOutline' : 'PlayCircleOutline'"
        align="Sub"
      ></ftr-icon>
      {{ isAutoUpdateEnabled ? 'Pause' : 'Resume' }} auto update
    </a>
  </div>
  <span class="live-action-bar__status" [ngClass]="'live-action-bar__status--' + liveness">{{
    liveness | titlecase
  }}</span>
</div>
